import React, { useState } from 'react';
import { motion } from 'framer-motion';

import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, index, onRequestQuote }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleRequestQuote = () => {
    onRequestQuote?.(service);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      className="group relative bg-white/80 dark:bg-slate-800/40 backdrop-blur-xl border border-slate-200 dark:border-white/10 rounded-3xl overflow-hidden shadow-2xl hover:border-blue-500/30 transition-all duration-300"
    >
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={service?.image}
          alt={service?.imageAlt}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 via-blue-800/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500" />

        <div className="absolute top-4 right-4 bg-amber-500 text-slate-900 px-3 py-1 md:px-4 md:py-1.5 rounded-full text-xs md:text-sm font-semibold">
          {service?.category}
        </div>

        <div className="absolute bottom-4 left-4 right-4">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
              <Icon name={service?.icon} size={24} className="text-white" />
            </div>
            <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-white" style={{ fontFamily: 'var(--font-headline)' }}>
              {service?.title}
            </h3>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6">
        <p className="text-sm md:text-base text-slate-600 dark:text-slate-400 mb-4 line-clamp-2">
          {service?.description}
        </p>

        <div className="space-y-3 mb-4">
          {service?.features?.slice(0, 3)?.map((feature, idx) => (
            <div key={idx} className="flex items-start gap-2">
              <Icon name="CheckCircle2" size={16} className="text-green-400 mt-0.5 flex-shrink-0" />
              <span className="text-xs md:text-sm text-slate-600 dark:text-slate-300">{feature}</span>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-slate-200 dark:border-white/10">
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={16} className="text-slate-500 dark:text-slate-400" />
            <span className="text-xs md:text-sm text-slate-500 dark:text-slate-400">{service?.deliveryTime}</span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            iconName="ArrowRight"
            iconPosition="right"
            className="text-blue-400 hover:text-blue-300"
          >
            En savoir plus
          </Button>
        </div>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: isHovered ? 1 : 0, y: isHovered ? 0 : 10 }}
        className="absolute inset-0 bg-blue-900/95 backdrop-blur-sm p-6 flex flex-col justify-center items-center text-center pointer-events-none"
      >
        <Icon name={service?.icon} size={48} className="text-white mb-4" />
        <h4 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'var(--font-headline)' }}>
          {service?.title}
        </h4>
        <p className="text-sm text-white/90 mb-4 line-clamp-3">
          {service?.fullDescription}
        </p>
        <div className="flex gap-2 pointer-events-auto">
          <Button
            variant="default"
            size="sm"
            iconName="CreditCard"
            iconPosition="left"
            onClick={handleRequestQuote}
          >
            Demander un Devis
          </Button>
          <Button variant="outline" size="sm" className="bg-white/10 text-white border-white/20 hover:bg-white/20">
            Détails
          </Button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ServiceCard;
